export default "__VITE_ASSET__BurHQC23__"